import styled from 'styled-components';

export const Contain = styled.div`
  height: 100%;
  width: 98%;
  margin: auto;
`;

export const Label = styled.p`
  font-size: 13pt;
  font-weight: 600;
  margin-right: 5px;
  margin-bottom: 0;
  font-size: ${props => props.fontSize};
`;

export const Valor = styled.p`
  margin-bottom: 10px;
  margin-top: ${props => props.marginTop};
`;

export const ContainerComentario = styled.div`
  margin-bottom: 10px;
`;

export const ValorDestaque = styled.p`
  margin-bottom: 10px;
  margin-top: ${props => props.marginTop};
  font-weight: 900;
  color: var(--primary-color-sefaz);
  font-size: 16pt;
  font-size: ${props => (props.fontSize ? props.fontSize : '16pt')};
`;

export const ContainerLabelValorTitulo = styled.div`
  display: flex;
  margin: 10px;
  padding: 3px;
  #iconHelp {
    margin-top: 5px;
    margin-right: 10px;
  }
`;

export const ContainerLabelValor = styled.div`
  margin: 10px;
  padding: 3px;
  width: ${props => props.width || '15%'};
`;

export const Titulo = styled.h1`
  font-size: 25pt;
  font-weight: 400;
  padding: 30px 0 10px 0;
  color: var(--primary-color-sefaz);
  margin-bottom: 0;
  margin-top: ${props => props.marginTop};
`;
